import { Experiments } from 'constants/experiments'
import useExperiment from 'hooks/Experiments/useExperiment'

const READ_EXPERIMENT_WITHOUT_ACTIVATION = { canActivate: false }

function useFixedFlashLengthOfStayExperiment(canActivate = false): boolean {
  const { isAnyVariant } = useExperiment(Experiments.croFixedFlashLengthOfStay, canActivate ? undefined : READ_EXPERIMENT_WITHOUT_ACTIVATION)

  return isAnyVariant
}

export default useFixedFlashLengthOfStayExperiment
